import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment, Autocomplete } from '@mui/material';
import { Flag } from '@mui/icons-material';
import countries from './countries';

const fieldSx = {
    '& .MuiOutlinedInput-root': {
        '&:hover fieldset': { borderColor: '#153247' },
        '&.Mui-focused fieldset': { borderColor: '#153247' },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#153247' },
};

const CountryInput = ({ value, onChange, onValidation, disabled, required }) => {
    const [inputValue, setInputValue] = useState(value || '');
    const [error, setError] = useState(null);

    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    const validate = (val) => {
        if (!val) {
            const msg = required ? 'Ce champ est obligatoire' : null;
            setError(msg);
            if (onValidation) onValidation(msg);
            return;
        }
        if (countries.includes(val)) {
            setError(null);
            if (onValidation) onValidation(null);
        } else {
            const msg = 'Veuillez sélectionner un pays valide dans la liste';
            setError(msg);
            if (onValidation) onValidation(msg);
        }
    };

    return (
        <Autocomplete
            freeSolo
            disabled={disabled}
            options={countries}
            inputValue={inputValue}
            onInputChange={(e, newInputValue) => {
                setInputValue(newInputValue);
                if (onChange) onChange(newInputValue);
                validate(newInputValue);
            }}
            onChange={(e, newValue) => {
                const val = newValue || '';
                setInputValue(val);
                if (onChange) onChange(val);
                validate(val);
            }}
            onBlur={() => validate(inputValue)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={<>Pays {required && <span style={{ color: 'red' }}>*</span>}</>}
                    error={!!error}
                    helperText={error}
                    disabled={disabled}
                    autoComplete="off"
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <>
                                <InputAdornment position="start">
                                    <Flag sx={{ color: '#153247' }} />
                                </InputAdornment>
                                {params.InputProps.startAdornment}
                            </>
                        ),
                    }}
                    sx={fieldSx}
                />
            )}
        />
    );
};

export default CountryInput;